import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let cache = null;

export const clearSitePagesCache = () => { cache = null; };

// Published imported pages that should appear in the header menu / footer.
export default function useSitePages() {
  const [pages, setPages] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    axios.get(`${API}/site-pages`).then((r) => { cache = r.data; setPages(r.data); }).catch(() => {});
  }, []);
  return pages;
}
